export const GA_COMPONENT_CSS_ATTRIBUTE_NAME = 'data-ga_component';

/**
 * Adds GA component to sport
 * @param {Element} element the element to add ga to
 * @param {String} componentName the GA component name
 * @return {void}
 */
export function setAsGaComponent(element, componentName) {
    element.setAttribute(GA_COMPONENT_CSS_ATTRIBUTE_NAME, `${componentName}`);
}
